<div class="g-0">
    <div class="row">
        <div class="col">
            <div class="box-wrapper">
                <div class="box-content-header">
                    <div class="row p-1">
                        <div class="col">
                            <div class="px-2 d-flex justify-content-between align-items-center">
                                <div>
                                    <i class="fa-regular fa-pen-to-square"></i>
                                    <span class="ms-2">Actualizare proiect</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="box-content-body">
                    <div class="col p-2 d-flex justify-content-start">
                        <div>
                            <mat-button-toggle-group name="fontStyle" aria-label="Font Style"
                                (change)="onActionChange($event)" value="status">
                                <mat-button-toggle value="status">Status</mat-button-toggle>
                            </mat-button-toggle-group>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col">
                            <div>
                                <form [formGroup]="sendUpdateStatusForm" (ngSubmit)="submitUpdateStatusMessage()">
                                    <div class="row p-1">
                                        <div class="col">
                                            <mat-form-field class="w-100" appearance="fill">
                                                <mat-label>Status</mat-label>
                                                <mat-select formControlName="status">
                                                    <mat-option *ngFor="let row of proiectStatuses" [value]="row.id">
                                                        {{ row.name }}
                                                    </mat-option>
                                                </mat-select>
                                                <mat-error>Selectați un status</mat-error>
                                            </mat-form-field>
                                        </div>
                                    </div>
                                    <div class="row p-1">
                                        <div class="col">
                                            <div class="fw-bold">Detalii</div>
                                            <angular-editor formControlName="description"
                                                [config]="editorConfig"></angular-editor>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col">
                                            <div class="col d-flex justify-content-end">
                                                <button
                                                    *ngIf="permissionsService.hasPermission('monitoring-module.proiecte.proiecte-view.update')"
                                                    [disabled]="sendUpdateStatusForm.invalid"
                                                    class="btn btn-light upload-btn m-1" type="submit">
                                                    <span class="upload__text">TRIMITE</span>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="section-spinner position-fixed" *ngIf="isLoading">
                    <div class="spinner position-absolute top-50 start-50 translate-middle">
                        <mat-spinner></mat-spinner>
                        <h3 class="mt-2">{{ helper.dialogConfig.generalMessages.pleaseWait }}</h3>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>